import { Injectable, Inject } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { DOCUMENT } from '@angular/common';
import { LocalizationService } from '../localization.service';
import { RoutesList } from 'src/app/models/enums/RoutesList';
import { PortalLoggedinUsers } from 'src/app/shared/services/portal-loggedin-users.service';
import { PortalLogOutExitCode } from 'src/app/models/enums/logOutExitCode';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private authService: AuthService,
    private router: Router,
    private portalLoggedinUsers: PortalLoggedinUsers
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): | boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    if(state.url == "/private" || state.url == "/private/en") {
      let homeUrl = state.url + '/home';
      return this.router.createUrlTree([homeUrl]);
    }

    if (this.authService.isAuthenticated()) {
      this.portalLoggedinUsers.startUpdateLastSeenDateInterval(this.authService);

      if (state.url.includes('/login')) {
        // This checks if the user is trying to access login page
        return this.router.createUrlTree(['/private/home']); // Redirect them to the private home page
      }
      // Redirect to home if trying to access login (or similar) pages while already logged in
      else if (state.url.includes('/en/login')) {
        // This checks if the user is trying to access login page
        return this.router.createUrlTree(['/private/en/home']); // Redirect them to the private home page
      }

      return true;
    }
    //It is not Authenticated
    this.authService.logout(PortalLogOutExitCode.AuthGuard, true);
    if (
      state.url.includes('/public/login') ||
      state.url.includes('/public/en/login')
    ) {
      return true;
    }

    let urlWithoutParams = this.router
      .parseUrl(state.url)
      .root.children['primary'].segments.map((it) => it.path)
      .join('/');
    let params =
      window.location.search && window.location.search != ''
        ? window.location.search
        : null;

    const anchor = window.location.hash ? window.location.hash.substring(1) : null;
    this.router.navigate([LocalizationService.getRoute(RoutesList.LoginPage)], {
      queryParams: { returnUrl: urlWithoutParams, params, anchor },
    });
    return false;
  }
}
